const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextBtnsState = () => {
    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
    else prevBtn.setAttribute('disabled', 'disabled')

    if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
    else nextBtn.setAttribute('disabled', 'disabled')
  }

  emblaApi
    .on('select', togglePrevNextBtnsState)
    .on('init', togglePrevNextBtnsState)
    .on('reInit', togglePrevNextBtnsState)

  return () => {
    prevBtn.removeAttribute('disabled')
    nextBtn.removeAttribute('disabled')
  }
}

const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev()
  }
  const scrollNext = () => {
    emblaApi.scrollNext()
  }
  prevBtn.addEventListener('click', scrollPrev, false)
  nextBtn.addEventListener('click', scrollNext, false)

  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
    emblaApi,
    prevBtn,
    nextBtn
  )

  return () => {
    removeTogglePrevNextBtnsActive()
    prevBtn.removeEventListener('click', scrollPrev, false)
    nextBtn.removeEventListener('click', scrollNext, false)
  }
}


const addThumbBtnsClickHandlers = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const scrollToIndex = slidesThumbs.map(
    (_, index) => () => emblaApiMain.scrollTo(index)
  );

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener('click', scrollToIndex[index], false);
  });

  document.addEventListener('variant:updated', function (e) {
    const slides = document.querySelectorAll('.embla__slide');
    const targetVariantId = e.detail.variant.id; // The updated variant ID
    // console.log('Target Variant ID:', targetVariantId);
  
    slides.forEach((slide) => {
      const slideVariantIds = slide.getAttribute('data-variant-id');
      if (!slideVariantIds) {
        return;
      }
  
      // Check if targetVariantId exists in the comma-separated list
      if (slideVariantIds.split(',').includes(String(targetVariantId))) {
        const slideIndex = parseInt(slide.getAttribute('data-slide-index'), 10);
        // console.log('Matching slide index:', slideIndex);
        emblaApiMain.scrollTo(slideIndex);
      }
    });
  });

  return () => {
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.removeEventListener('click', scrollToIndex[index], false);
    });
  };
};

const addToggleThumbBtnsActive = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const toggleThumbBtnsState = () => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
    const previous = emblaApiMain.previousScrollSnap();
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[previous].classList.remove('embla-thumbs__slide--selected');
    slidesThumbs[selected].classList.add('embla-thumbs__slide--selected');
  };

  emblaApiMain.on('select', toggleThumbBtnsState);
  emblaApiThumb.on('init', toggleThumbBtnsState);

  return () => {
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[selected].classList.remove('embla-thumbs__slide--selected');
  };
};

const OPTIONS = {
  loop: true,
};
const OPTIONS_THUMBS = {
  containScroll: 'keepSnaps',
  loop: true,
  dragFree: true,
};

const viewportNodeMainCarousel = document.querySelector('.embla__viewport');
const viewportNodeThumbCarousel = document.querySelector(
  '.embla-thumbs__viewport'
);
const prevBtnNode = document.querySelector('.embla__button--prev') || null;
const nextBtnNode = document.querySelector('.embla__button--next') || null;
const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS);
const emblaApiThumb = EmblaCarousel(viewportNodeThumbCarousel, OPTIONS_THUMBS);

const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
  emblaApiMain,
  emblaApiThumb
);
const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
  emblaApiMain,
  emblaApiThumb
);

if(prevBtnNode && nextBtnNode) {
  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
    emblaApiMain,
    prevBtnNode,
    nextBtnNode
  )
}

emblaApiMain
  .on('destroy', removeThumbBtnsClickHandlers)
  .on('destroy', removeToggleThumbBtnsActive);

emblaApiThumb
  .on('destroy', removeThumbBtnsClickHandlers)
  .on('destroy', removeToggleThumbBtnsActive);
